import axios from '../../../axios';

const url = '/invoicingservice/api/client-analytics';

export const getTotalPlacements = (period: string, businessUnitId?: string) =>
  axios.get(
    `${url}/total-placements?period=${period}${
      businessUnitId ? '&businessUnitId=' + businessUnitId : ''
    }`
  );

export const getTopClients = (currency?: string) =>
  axios.get(`${url}/top-clients?currency=${currency}`);

export const getSalesTrendOrderbookwise = (
  currency: string,
  period: string,
  businessUnitId?: string
) =>
  axios.get(
    `${url}/sales-trend-orderbookwise?currency=${currency}&period=${period}${
      businessUnitId ? '&businessUnitId=' + businessUnitId : ''
    }`
  );

export const getSalesByAM = (currency: string, quarter: string) =>
  axios.get(`${url}/sales-by-am?currency=${currency}&quarter=${new Date(quarter).toISOString()}`);

export const getOrderbookClientwiseMonthly = (currency: string, quarter: string) =>
  axios.get(
    `${url}/orderbook-clientwise-monthly?currency=${currency}&quarter=${new Date(
      quarter
    ).toISOString()}`
  );
